const headerSearchButton = $('.header-search-toggle');
const SearchTooltip = $('.tooltip-search');

document.addEventListener('DOMContentLoaded', () => {
  headerSearchButton.on('click', () => {
    SearchTooltip.toggleClass('is-open');
  });
});
